import authService from '@/services/auth';
import { PROFILE } from '@/constants/routes';

export default function checkAuth({ next }) {
  const hasAuthTokens = authService.hasAuthTokens();
  if (hasAuthTokens) return next({ name: PROFILE });
  return next();
}
